import React from "react";

export default function Spinner({ className = "" }) {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div className="animate-spin h-10 w-10 border-4 border-brand-green border-t-transparent rounded-full" />
    </div>
  );
}
